export enum DATA_QA {
  ROOT = 'modal-wrapper',
  DIALOG = 'modal-wrapper-dialog',
  CLOSE = 'modal-wrapper-close',
}
